import AnswerList from './answerList';
export default AnswerList;
